// Social screens' copy in Spanish (the Dutch in lib/social/copy.ts is the source), in our own words.
export const socialHubEs = {
  "social.about.section.account": "Cuenta",
  "social.about.sync.title": "Lleva tus notas contigo",
  "social.about.sync.action": "Iniciar sesión",
  "social.about.sync.manage": "Gestionar",
  "social.about.sync.signedInAs": "Sesión iniciada como {email}",
  "social.about.sync.unconfirmed":
    "Ahora no hemos podido comprobar tu cuenta; sigues con la sesión iniciada y lo intentaremos de nuevo en un momento.",
  "social.signin.gate.title": "Inicia sesión para catar juntos",
  "social.signin.gate.body":
    "Los amigos, los grupos y las catas van ligados a una cuenta. Las notas de este dispositivo siguen siendo tuyas.",
  "social.signin.gate.action": "Iniciar sesión",
  "social.about.public.label": "Localizable para mensajes a «todos»",
  "social.about.public.hint":
    "Actívalo para que los amigos que no están en tus grupos puedan llegar a ti con un mensaje a «todos» en una cata. Solo controla quién puede enviarte mensajes generales, no si apareces en la búsqueda; eso se decide en «Otros pueden encontrarte».",
  "social.about.discoverable.label": "Otros pueden encontrarte",
  "social.about.discoverable.hint":
    "Tu nombre de usuario y tu nombre aparecen en las búsquedas de otros usuarios. Desactívalo para no aparecer.",
  "social.signin.title": "Iniciar sesión",
  "social.signin.subtitle": "Elige cómo quieres iniciar sesión",
  "social.signin.provider.google": "Google",
  "social.signin.provider.microsoft": "Microsoft",
  "social.signin.provider.instagram": "Instagram",
  "social.signin.provider.tiktok": "TikTok",
  "social.signin.provider.pending": "Aún no disponible: pendiente de revisión por el proveedor",
  "social.signin.error.denied": "El inicio de sesión se canceló o se rechazó.",
  "social.signin.error.generic": "No se pudo iniciar sesión. Inténtalo de nuevo.",
  "social.signin.success.title": "Sesión iniciada",
  "social.friends.title": "Amigos",
  "social.friends.empty.title": "aún no hay amigos",
  "social.friends.empty.body": "Añade a un amigo para catar juntos.",
  "social.friends.empty.action": "Añadir amigo",
  "social.friends.incoming.title": "Solicitudes",
  "social.friends.incoming.accept": "Aceptar",
  "social.friends.incoming.decline": "Rechazar",
  "social.friends.outgoing.label": "Solicitud enviada",
  "social.friends.outgoing.cancel": "Cancelar solicitud",
  "social.friends.row.block": "Bloquear",
  "social.friends.row.unblock": "Desbloquear",
  "social.friends.row.remove": "Quitar",
  "social.friends.accepted.toast": "Ya sois amigos",
  "social.friends.add.title": "Añadir amigo",
  "social.friends.add.searchPlaceholder": "Nombre o nombre de usuario",
  "social.friends.add.send": "Enviar solicitud",
  "social.friends.add.queued": "Se enviará cuando vuelvas a tener conexión",
  "social.friends.add.sent": "Enviada",
  "social.friends.add.noResults": "Sin resultados",
  "social.friends.add.action": "Añadir",
  "social.friends.search.resultCount": "{n} resultados",
  "social.groups.title": "Grupos",
  "social.groups.empty.title": "aún no hay grupos",
  "social.groups.empty.body": "Crea un grupo para catar juntos.",
  "social.groups.empty.action": "Crear grupo",
  "social.groups.memberCount": "{n} miembros",
  "social.groups.role.owner": "propietario",
  "social.groups.role.admin": "administrador",
  "social.groups.role.member": "miembro",
  "social.groups.create.title": "Crear grupo",
  "social.groups.create.name": "Nombre",
  "social.groups.create.description": "Descripción (opcional)",
  "social.groups.create.confirm": "Crear",
  "social.groups.edit.title": "Editar grupo",
  "social.groups.edit.confirm": "Guardar",
  "social.groups.avatar.upload": "Elegir foto",
  "social.groups.avatar.uploading": "Subiendo…",
  "social.groups.avatar.remove": "Quitar foto",
  "social.groups.visibility.label": "Quién puede ver este grupo",
  "social.groups.visibility.membersAndInvitees": "Visible para miembros e invitados",
  "social.groups.visibility.membersOnly": "Solo miembros, sin vista previa del enlace",
  "social.groups.visibility.discoverable": "Aparece en el directorio de grupos",
  "social.groups.directory.entry": "Buscar un grupo",
  "social.groups.directory.title": "Buscar un grupo",
  "social.groups.directory.searchPlaceholder": "Nombre del grupo",
  "social.groups.directory.noResults": "No se encontraron grupos",
  "social.groups.directory.resultCount": "{n} resultados",
  "social.groups.directory.requestToJoin": "Solicitar unirse",
  "social.groups.directory.requested": "Solicitado",
  "social.groups.joinRequests.title": "Solicitudes",
  "social.groups.joinRequests.accept": "Aceptar",
  "social.groups.joinRequests.decline": "Rechazar",
  "social.groups.invitePermission.label": "Quién puede invitar",
  "social.groups.invitePermission.ownerAdmin": "Solo propietarios y administradores",
  "social.groups.invitePermission.anyMember": "Cualquier miembro",
  "social.groups.detail.editAction": "Editar grupo",
  "social.groups.detail.removeMember": "Quitar",
  "social.groups.detail.leave": "Salir del grupo",
  "social.groups.detail.delete": "Eliminar grupo",
  "social.groups.detail.loadMore": "Mostrar más",
  "social.groups.detail.zeroOwnerLeaveBlocked":
    "Primero transfiere la propiedad o elimina el grupo",
  "social.groups.invite.title": "Invitar",
  "social.groups.invite.noFriends": "No hay amigos a quienes invitar.",
  "social.session.title": "Cata",
  "social.session.draft.nameLabel": "Nombre",
  "social.session.draft.invite": "Invitar",
  "social.session.draft.startNow": "Empezar ahora",
  "social.session.scheduled.label": "Prevista para el {date}",
  "social.session.action.schedule": "Programar",
  "social.session.action.start": "Empezar",
  "social.session.action.cancel": "Cancelar",
  "social.session.action.end": "Terminar",
  "social.session.status.invited": "invitado",
  "social.session.status.joined": "se ha unido",
  "social.session.status.online": "en línea",
  "social.session.status.offline": "sin conexión",
  "social.session.status.live": "En directo",
  "social.session.ended.title": "Terminada",
  "social.session.ended.toast": "esta cata ha terminado",
  "social.session.reconnecting": "Reconectando…",
  "social.session.presenceCount": "{n} en línea",
  "social.session.schedule.date": "Fecha (opcional)",
  "social.session.schedule.time": "Hora (opcional)",
  "social.session.schedule.invalid": "Elige una fecha y una hora futuras.",
  "social.session.invite.title": "Invitar a participantes",
  "social.session.invite.confirm": "Invitar",
  "social.session.invite.sourceFriends": "Amigos",
  "social.session.invite.sourceGroup": "Grupo",
  "social.broadcast.composer.title": "Enviar un mensaje",
  "social.broadcast.composer.targetFriends": "Amigos",
  "social.broadcast.composer.targetGroup": "Grupo",
  "social.broadcast.composer.targetEveryone": "Todos en esta cata",
  "social.broadcast.composer.textPlaceholder": "Tu mensaje…",
  "social.broadcast.composer.send": "Enviar",
  "social.broadcast.composer.queued": "Se enviará cuando vuelvas a tener conexión",
  "social.broadcast.composer.sent": "Enviado",
  "social.broadcast.composer.sentPartial": "Enviado, {n} sin entregar",
  "social.broadcast.panel.title": "Dirigido a ti en esta cata",
  "social.broadcast.panel.empty": "Aún no hay nada dirigido a ti en esta cata",
  "social.presence.online": "en línea",
  "social.presence.offline": "sin conexión",
  "social.invite.friends.action": "Invitar",
  "social.invite.friends.title": "Invitar a amigos",
  "social.invite.friends.lead":
    "Envía tu enlace personal. Quien lo abra e inicie sesión se hará amigo tuyo.",
  "social.invite.group.title": "Invitar a {group}",
  "social.invite.group.lead": "Quien abra el enlace o escriba el código entra en el grupo.",
  "social.invite.channel.whatsapp": "WhatsApp",
  "social.invite.channel.email": "Correo",
  "social.invite.channel.sms": "SMS",
  "social.invite.channel.copy": "Copiar enlace",
  "social.invite.channel.copied": "Enlace copiado",
  "social.invite.qr.label": "Código QR con la invitación",
  "social.invite.code.label": "O díctale este código",
  "social.invite.code.until": "Válido hasta {time}",
  "social.invite.status": "Quedan {left} de {max} usos, válido hasta {date}",
  "social.invite.audience.one": "Una persona",
  "social.invite.audience.many": "Hasta 10 personas",
  "social.invite.audience.manyHint": "Si son más personas, confirmas tú cada solicitud.",
  "social.invite.approval.label": "Aprobar primero a los nuevos miembros",
  "social.invite.joined.title": "Quién se unió",
  "social.invite.revoke": "Revocar enlace",
  "social.invite.revoked": "Este enlace ya no funciona.",
  "social.invite.renew": "Crear un enlace nuevo",
  "social.invite.landing.title": "Invitación",
  "social.invite.landing.friend": "{name} te invita a catar juntos.",
  "social.invite.landing.group": "{name} te invita a unirte a {group}.",
  "social.invite.landing.groupHidden": "{name} te invita a unirte a un grupo.",
  "social.invite.landing.approval": "Un administrador aprobará tu solicitud.",
  "social.invite.landing.expires": "Válido hasta {date}",
  "social.invite.landing.accept": "Aceptar",
  "social.invite.landing.decline": "No, gracias",
  "social.invite.landing.signIn": "Inicia sesión para aceptar",
  "social.invite.landing.gone.title": "Esta invitación ya no funciona",
  "social.invite.landing.gone.body": "Pide un enlace o un código nuevo.",
  "social.invite.landing.none.title": "No se encontró ninguna invitación",
  "social.invite.landing.none.body": "Abre el enlace de nuevo o escribe el código.",
  "social.invite.outcome.friends": "Ya sois amigos",
  "social.invite.outcome.requested": "Solicitud enviada. {name} la confirmará.",
  "social.invite.outcome.joined": "Ya eres miembro del grupo",
  "social.invite.outcome.joinRequested": "Solicitud enviada. Un administrador la aprobará.",
  "social.invite.outcome.toFriends": "Ir a amigos",
  "social.invite.outcome.toGroup": "Ir al grupo",
  "social.code.action": "¿Tienes un código?",
  "social.code.title": "Introducir un código",
  "social.code.hint": "Tres palabras para una invitación, seis para una cata.",
  "social.code.placeholder": "p. ej. leaf lime loft",
  "social.code.submit": "Continuar",
  "social.code.invalid": "Eso no es un código. Revisa las palabras otra vez.",
  "social.samen.title": "Juntos",
  "social.samen.badge": "{label}, {count} nuevos",
  "social.samen.announce": "{count} nuevos en Juntos",
  "social.samen.profile": "Tu perfil",
  "social.samen.lead": "Tus amigos, tus grupos y lo que te espera.",
  "social.inbox.title": "Bandeja",
  "social.inbox.tab.received": "Recibidos",
  "social.inbox.tab.sent": "Enviados",
  "social.inbox.tab.updates": "Novedades",
  "social.inbox.empty.received": "No te espera nada.",
  "social.inbox.empty.sent": "No esperas a nadie.",
  "social.inbox.empty.updates": "Aún no hay novedades.",
  "social.inbox.friendRequest": "quiere ser tu amigo",
  "social.inbox.groupInvite": "{name} te invita a {group}",
  "social.inbox.groupInviteAnonymous": "Invitación a {group}",
  "social.inbox.joinRequest": "quiere unirse a {group}",
  "social.inbox.sessionInvite": "{name} te invita a {session}",
  "social.inbox.accept": "Aceptar",
  "social.inbox.decline": "Rechazar",
  "social.inbox.open": "Ver",
  "social.inbox.cancel": "Retirar",
  "social.inbox.remind": "Recordar",
  "social.inbox.reminded": "Recordado",
  "social.inbox.sent.friendRequest": "Solicitud de amistad",
  "social.inbox.sent.groupInvite": "Invitado a {group}",
  "social.inbox.links.title": "Tus enlaces",
  "social.inbox.link.friend": "Enlace personal",
  "social.inbox.link.group": "Enlace a {group}",
  "social.inbox.link.ended": "Ya no funciona",
  "social.inbox.link.joined": "Se unieron: {names}",
  "social.inbox.update.friendAccepted": "{name} ya es tu amigo",
  "social.inbox.update.groupInviteAccepted": "{name} se ha unido a {group}",
  "social.inbox.update.joinApproved": "Has entrado en {group}",
  "social.inbox.someone": "Alguien",
  "social.inbox.aGroup": "un grupo",
  "social.inbox.queued": "Se procesará cuando vuelvas a tener conexión",
  "social.profile.title": "Perfil",
  "social.profile.lead": "Así te ven los demás.",
  "social.profile.noGroups": "Aún no estás en ningún grupo.",
  "social.profile.signedOut": "Inicia sesión para tener un perfil que vean tus amigos.",
  "social.settings.title": "Ajustes",
  "social.settings.open": "Abrir ajustes",
  "social.notify.title": "Notificaciones",
  "social.notify.invites": "Invitaciones y solicitudes",
  "social.notify.invites.hint":
    "Una notificación cuando alguien te invita o quiere ser tu amigo. Quién ha aceptado lo ves en tu bandeja.",
  "social.notify.quiet": "Horas de silencio",
  "social.notify.quiet.from": "Desde",
  "social.notify.quiet.until": "Hasta",
  "social.notify.quiet.hint":
    "En estas horas no hay notificaciones; todo sigue llegando a tu bandeja. Como máximo {n} notificaciones al día.",
  "social.notify.mutes.title": "Silenciados",
  "social.notify.mutes.empty":
    "No has silenciado a nadie. Un amigo o grupo silenciado ya no te envía notificaciones.",
  "social.notify.mute": "Silenciar",
  "social.notify.unmute": "Dejar de silenciar",
  "social.groups.inviteFriends": "Invitar a amigos",
  "social.groups.inviteFriends.sent": "{n} invitados. Se unen en cuanto acepten.",
  "social.groups.inviteLink": "Compartir enlace",
  "social.groups.log.title": "Registro",
  "social.groups.log.empty": "Aún no ha pasado nada.",
  "social.groups.log.created": "{name} creó el grupo",
  "social.groups.log.joined": "{name} se unió",
  "social.groups.log.left": "{name} salió del grupo",
  "social.groups.log.removed": "{name} fue quitado del grupo",
  "social.groups.log.role": "{name} ahora es {role}",
  "social.groups.mute": "Silenciar grupo",
  "social.groups.unmute": "Dejar de silenciar grupo",
  "social.share.title": "Compartir",
  "social.share.action": "Compartir",
  "social.share.shared": "Compartido",
  "social.share.copied": "Enlace copiado",
  "social.invite.channel.share": "Compartir…",
  "social.inbox.link.reshare": "Compartir de nuevo",
} as const;
